import axiosInstance from "./axiosInstance";

class InquiryService {
  static async getInquiries(category?: string | null): Promise<any[]> {
    try {
      const response = await axiosInstance.get<ApiResponse<any>>(
        `/inquiry/getAllBy`,
        {
          params: {
            category,
          },
        },
      );
      return response.data.result.inquiryDTOList;
    } catch (error) {
      console.error("Error fetching inquiries:", error);
      throw error;
    }
  }

  static async deleteInquiry(id: number): Promise<any> {
    try {
      const response = await axiosInstance.delete<ApiResponse<any>>(
        `/inquiry/${id}`,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async getInquiry(id: string): Promise<any> {
    try {
      const response = await axiosInstance.get<ApiResponse<any>>(
        `/inquiry/${id}`,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }
  static async getInquiryUnRead(): Promise<any> {
    try {
      const response = await axiosInstance.get<ApiResponse<any>>(
        `/inquiry/count/unread`,
      );
      return response.data?.result;
    } catch (error) {
      throw error;
    }
  }

  static async creareInquiry(request: any): Promise<any> {
    // Prepare form data for non-file data (title, inquiry, category)
    const formData = new FormData();
    formData.append("title", request.title);
    formData.append("name", request.name);
    formData.append("email", request.email);
    formData.append("phone", request.phone);
    formData.append("inquiry", request.titleI);
    formData.append("category", request.selectedCategory || "");

    // Convert base64 images to File objects
    const imagePromises = request.imageSrcs.map(
      async (imageSrc: string, index: number) => {
        const blob = await fetch(imageSrc).then((res) => res.blob());
        return new File([blob], `image-${index}.jpg`, { type: blob.type });
      },
    );

    const imageFiles = await Promise.all(imagePromises);
    imageFiles.forEach((file) => formData.append("images", file));

    try {
      const response = await axiosInstance.post("/inquiry", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data.result;
    } catch (error) {
      throw error;
    }
  }
  static async getFAQ(productType?: string | null): Promise<any> {
    try {
      const response = await axiosInstance.get<ApiResponse<any[]>>(
        `/inquiry/faq`,
        {
          params: {
            productType,
          },
        },
      );
      return response.data.result;
    } catch (error) {
      throw error;
    }
  }
}

export default InquiryService;
